<template>
    <div class="live-page wahoo-bay-page">
        <div class="case-study">

<h1>Wahoo Bay Marine Conservation Park</h1>

<p class="meta"><strong>Pompano Beach, Florida, USA</strong></p>
<p><strong>System:</strong> Octopus™ Pan-Tilt-Zoom Underwater Observatory</p>
<p><strong>Application:</strong> Education, Conservation, Public Engagement & Habitat Restoration</p>

<div class="pink-line"></div>

<div class="deployment-scene" aria-hidden="true">
    <MotionMedia :src="previewVideo" />
</div>

<section class="deployment-live">
    <h2>Watch Live</h2>

    <div class="video-container">
        <iframe
            :key="$route.fullPath"
            loading="lazy"
            width="960"
            height="540"
            src="https://www.youtube.com/embed/oBTGY6Ax870"
            title="Wahoo Bay"
            frameborder="0"
            allowfullscreen>
        </iframe>
    </div>
</section>

<section>
    <h2>Project Overview</h2>

    <p>
        Wahoo Bay is a one-of-a-kind marine conservation and education park located in
        Pompano Beach, Florida. Developed through a public-private partnership, the project
        was designed to create an immersive marine experience that connects visitors with
        South Florida's coastal ecosystems while promoting conservation, environmental
        awareness, and stewardship.
    </p>

    <p>
        Powered by a Fathom Ocean Octopus™ underwater observatory, Wahoo Bay provides a
        live view into a protected marine habitat, allowing students, researchers, and the
        public to observe marine life in real time from anywhere in the world.
    </p>
</section>

<div class="pink-line"></div>

<section>
    <h2>The Challenge</h2>

    <p>
        The Wahoo Bay team sought to create an engaging educational environment that would
        inspire future generations to care for and protect marine ecosystems.
    </p>

    <p>
        They needed a solution capable of providing continuous underwater observation while
        supporting conservation initiatives, habitat restoration efforts, scientific monitoring,
        and public outreach. The system also needed to operate reliably in a dynamic coastal
        environment and be accessible to both onsite visitors and virtual audiences.
    </p>
</section>

<div class="pink-line"></div>

<section>
    <h2>The Fathom Ocean Solution</h2>

    <p>
        Fathom Ocean deployed an Octopus™ Pan-Tilt-Zoom underwater observatory system
        to provide continuous real-time access to the marine habitat within Wahoo Bay.
    </p>

    <p><strong>Key system capabilities include:</strong></p>

    <ul>
        <li>Remote pan-tilt-zoom control</li>
        <li>Self-cleaning optics</li>
        <li>Continuous live streaming</li>
        <li>Long-term underwater deployment</li>
        <li>Public viewing access</li>
        <li>Educational and research applications</li>
    </ul>

    <p>
        Positioned among the park's innovative SEAHIVE™ habitat structures, the system captures
        marine life activity while providing an engaging educational experience for visitors of all ages.
    </p>
</section>

<div class="pink-line"></div>

<section>
    <h2>Impact & Results</h2>

    <p>
        Wahoo Bay has become a living laboratory that supports conservation,
        education, and community engagement.
    </p>

    <p><strong>Project outcomes include:</strong></p>

    <ul>
        <li>Real-time observation of marine life</li>
        <li>Educational experiences for students and classrooms</li>
        <li>Increased public awareness of coastal ecosystems</li>
        <li>Support for habitat restoration initiatives</li>
        <li>Community engagement through live streaming</li>
        <li>Opportunities for scientific research and environmental monitoring</li>
    </ul>

    <p>
        The camera regularly captures a variety of marine species including reef fish,
        sea turtles, rays, and other wildlife that utilize the habitat created within the park.
    </p>
</section>

<div class="pink-line"></div>

<section>
    <h2>Why This Project Matters</h2>

    <p>
        Wahoo Bay demonstrates how technology, education, and conservation can work
        together to create meaningful community impact.
    </p>

    <p>
        By combining habitat restoration, marine science, and live underwater observation,
        the project provides visitors with a direct connection to the marine environment while
        fostering a deeper appreciation for the importance of healthy coastal ecosystems.
    </p>

    <p>
        The result is a permanent educational resource that inspires curiosity, supports
        conservation, and helps make the underwater world accessible to everyone.
    </p>
</section>

<div class="pink-line"></div>

<section>
    <h2>System Configuration</h2>

    <ul>
        <li>Octopus™ PTZ Underwater Observatory</li>
        <li>Self-cleaning technology</li>
        <li>Remote operation</li>
        <li>Continuous livestreaming</li>
        <li>Long-term deployment</li>
        <li>Public education and conservation focused installation</li>
    </ul>
</section>

<div class="pink-line"></div>

<section>
    <h2>Interested in a Similar Project?</h2>

    <p>
        Whether you're a marina, educational institution, nonprofit organization,
        aquarium, or municipality, Fathom Ocean can help create a live underwater
        experience that supports education, conservation, and community engagement.
    </p>

    <b-button @click="$router.push('/contact')">
        Schedule a Consultation
    </b-button>
</section>
        </div>
    </div>
</template>

<script>
import MotionMedia from '@/components/journey/MotionMedia.vue'
import previewVideo from '@/assets/videos/wahoobay.mp4'

export default {
    name: 'WahooBay',
    components: {
        MotionMedia,
    },
    data() {
        return {
            previewVideo,
        }
    },
}
</script>
